import { delegate } from '@/utils/delegate'
import flatpickr from 'flatpickr'
import { DateTime } from 'luxon'

// function getEasternNow() {
//   // Get the current time in ET as a Date object
//   const now = new Date();
//   // Convert to ET using toLocaleString and then back to Date
//   return new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
// }

// function formatDateToYMDHMS(date) {
//   // Format a Date object as 'YYYY-MM-DD HH:mm:ss' in ET
//   const pad = n => n < 10 ? '0' + n : n;
//   return date.getFullYear() + '-' +
//     pad(date.getMonth() + 1) + '-' +
//     pad(date.getDate()) + ' ' +
//     pad(date.getHours()) + ':' +
//     pad(date.getMinutes()) + ':' +
//     pad(date.getSeconds());
// }

// function initializeDateTimePicker() {
//   $('#datetimepicker').datetimepicker({
//     format: 'Y-m-d H:i:s',
//     formatTime: 'H:i:s',
//     formatDate: 'Y-m-d',
//     validateOnBlur: false,
//     dayOfWeekStart: 1,
//     timepicker: true,
//     weeks: true,
//     step: 5,
//     onShow: function(ct) {
//       // Set minimum date to current ET
//       const etNow = getEasternNow();
//       this.setOptions({ minDate: etNow });
//     },
//     onChangeDateTime: function(dp, $input) {
//       if (!dp) return;
//       // dp is in the user's local time, so convert to ET string
//       const etDate = new Date(dp.toLocaleString('en-US', { timeZone: 'America/New_York' }));
//       $input.val(formatDateToYMDHMS(etDate));
//     }
//   });

//   // Add timezone explanation text
//   const timezoneNote = document.createElement('small');
//   timezoneNote.className = 'form-text text-muted mt-1';
//   timezoneNote.textContent = 'All times are in Eastern Time (ET)';
//   $('#datetimepicker').after(timezoneNote);
// }
console.log("release-mains.js loaded");
function loadForm(contentId, url) {
  const targetContent = document.getElementById(contentId);

  if (!targetContent) {
    console.error(new Error(`Could not find element with id ${contentId}`));
    return;
  }

  // Clear all form contents
  document.querySelectorAll('.form_content').forEach(content => {
    content.innerHTML = '';
  });

  fetch(url, {
    headers: {
      'X-CSRF-Token': csrfToken()
    }
  })
    .then(response => response.text())
    .then(html => {
      targetContent.innerHTML = html;
      setupFlatpickr(); // Ensure picker is initialized after form loads
    })
    .catch(error => console.error('Error loading form:', error));
}

function loadCloneForm(ev) {
  // Give the DOM a chance to update so we don't wipe out data while this tab is not active
  setTimeout(() => {
    const target = ev?.delegateTarget || ev?.target || document.findElementById('clone_job_tab')
    if (!target?.classList?.contains("active")) return;
    loadForm('new_clone_job_content', '/release_mains/load_clone_form');
  }, 10)
}

function loadDeploymentForm(ev) {
  // Give the DOM a chance to update so we don't wipe out data while this tab is not active
  setTimeout(() => {
    const target = ev?.delegateTarget || ev?.target || document.findElementById('deployment_tab')
    if (!target?.classList?.contains("active")) return;
    loadForm('new_deployment_content', '/release_mains/load_deployment_form');
  }, 10)
}


export function activate () {
  window.kipuPlugins = window.kipuPlugins || {}

  if (window.kipuPlugins.releaseMainsHandlers) return;
  window.kipuPlugins.releaseMainsHandlers = true;

  delegate('click', '#deployment_tab', loadDeploymentForm)
  delegate('click', '#clone_job_tab', loadCloneForm)

  return packLoader(() => {
    // initializeDateTimePicker()

    // Initially load the deployment form
    if (document.getElementById('new_deployment_content')) {
      loadForm('new_deployment_content', '/release_mains/load_deployment_form')
    }
  })
}

function setupFlatpickr() {
  var input = document.getElementById('datetimepicker');
  if (!input) return;
  flatpickr(input, {
    enableTime: true,
    dateFormat: "Y-m-d H:i:S",
    time_24hr: true,
    minDate: DateTime.now().setZone('America/New_York').toISO(),
    onChange: function(selectedDates, dateStr, instance) {
      if (!selectedDates.length) return;
      const formatted = instance.formatDate(selectedDates[0], "Y-m-d H:i:S");
      input.value = formatted;
      // Update the timezone note styling
      var note = document.getElementById('flatpickr-timezone-note');
      if (note) {
        note.classList.remove('text-muted');
        note.classList.add('text-danger', 'flash-tx-alert');
      }
    },
    onReady: function(selectedDates, dateStr, instance) {
      var note = document.createElement('small');
      note.id = 'flatpickr-timezone-note';
      note.className = 'form-text text-muted mt-1';
      note.textContent = 'All times are in Eastern Time (ET)';
      input.parentNode.appendChild(note);
    }
  });
}

document.addEventListener('DOMContentLoaded', setupFlatpickr);
document.addEventListener('turbolinks:load', setupFlatpickr);
document.addEventListener('turbo:load', setupFlatpickr);
